import { Checkbox } from 'primereact/checkbox';
import { useState } from 'react';

interface Props {
    name: string;
    add: (param: boolean) => void;
    init: boolean;
}

export const Boolean = ({name, add, init}: Props) => {
    const [checked, setChecked] = useState<boolean>(init);

    return (
        <>
            <div className="field-checkbox">
                <Checkbox
                    inputId={name}
                    checked={checked}
                    onChange={(e) => {
                        const isChecked: boolean = e.checked as boolean;
                        setChecked(isChecked);
                        add(isChecked);
                    }}
                />
                <label htmlFor={name} className="labelSourceExterne">
                    {name}
                </label>
            </div>
        </>
    );
};
